import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormControl, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router, ActivatedRoute } from '@angular/router';
import { EoiReadOnlyComponent } from '../eoi-read-only/eoi-read-only.component';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { environment } from '@/app/environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BriefSectionComponent } from '../brief-section/brief-section.component';
import { MatDialog } from '@angular/material/dialog';
import { EOIIndividualResponsePreviewComponent } from '@/app/components/projects/project-development/tendering/project-expression-of-interest/eoiindividual-response-preview/eoiindividual-response-preview.component';
import { InternalApprovalComponent } from '@/app/components/global/internal-approval/internal-approval.component';
import { UserService } from '@/app/services/user.service';
import { ApprovalResponseComponent } from '@/app/components/global/approval-response/approval-response.component';
import { WrapperComponent } from '../../../../wrapper/wrapper.component';
import { WarningMessages } from '@/app/enums/warning-messages.enum';
import { CustomTooltipComponent } from '@/app/components/global/custom-tooltip/custom-tooltip.component';
import { ToolTipMessages } from '@/app/enums/toolTipMessages.enum';
@Component({
  standalone: true,
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    EoiReadOnlyComponent,
    BriefSectionComponent,
    WrapperComponent,
    CustomTooltipComponent,
  ],
  selector: 'app-intiate-expression-of-interest',
  templateUrl: './intiate-expression-of-interest.component.html',
  styleUrls: ['./intiate-expression-of-interest.component.css'],
})
export class IntiateExpressionOfInterestComponent implements OnInit {
  projectId: any;
  eoiId: any;
  submittedInitiation: any;
  enrichedOrganizations: any;
  mapLink!: SafeResourceUrl;
  google_api_key = environment.apiKey;
  searchTerm = '';
  filteredOrganizations: any[] = [];
  resetRichTextEditor = false;
  eoiData: any;
  other = false;
  selectedWorkPackages: { id: number; name: string }[] = [];
  approvalsStatus: string;
  organizationControl = new FormControl();
  company_name = new FormControl();
  name = new FormControl();
  position = new FormControl();
  email = new FormControl();
  organizations: any;
  selectedOrganizations: any[] = [];
  sendApprovals = false;
  usersList: any;
  isCreator = false;
  approvalResponses: any;
  internalApproval: any;
  isInApprovers = false;
  approvalNote: any;
  projectName: string;
  isEdit = false;
  currentDialog = 'EOI';
  savedEOIData: any = [];
  projectIdentifier: string;
  showTemplateForm: boolean = false;

  roles = [
    'Admin',
    'Project Manager',
    'Site Supervisor',
    'Civil Engineer',
    'Quantity Surveyor',
    'Architect',
    'Safety Officer',
    'Construction Manager',
    'Procurement Officer',
    'Foreman',
  ];
  orgInfo: any;
  checkApprove: boolean;
  toolTipMessage = ToolTipMessages;
  showTooltip: boolean = false;
  constructor(
    private toast: NgToastService,
    private tenderingService: TenderingService,
    private sanitizer: DomSanitizer,
    private projectsService: ProjectsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    // NOTE: get project and eoi id's from url
    /**
     * (!) symbol called the non-null assertion operator in TypeScript.
     * It tells the TypeScript compiler that you are certain the value will not be null or undefined.
     */
    this.projectId = this.activatedRoute.snapshot.paramMap.get('projectId')!;
    this.eoiId = this.activatedRoute.snapshot.paramMap.get('eoiId')!;
    this.activatedRoute.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
      this.projectIdentifier = params['projectIdentifier'];
    });

    this.preInitiationData();
    this.submittedInitiationData();
    this.fetchUsers();
    this.getEoiApprovalsStatus();

    const orgInfoString = localStorage.getItem('org_info');
    if (orgInfoString) {
      this.orgInfo = JSON.parse(orgInfoString); // Converts the string to an object
    }
  }

  toggle() {
    this.showTemplateForm = !this.showTemplateForm;
  }
  otherSelection() {
    this.other = true;
  }

  submittedInitiationData(): any {
    return this.tenderingService
      .getSubmittedEoiInitiationData(this.projectId, this.eoiId)
      .subscribe({
        next: (response: any) => {
          this.submittedInitiation = response.data;
          this.enrichOrganizations();
          const initiator_id = response?.data?.initiator_id;
          if (initiator_id === this.orgInfo?.pivot?.user_id) {
            this.isCreator = true;
          } else {
            this.isCreator = false;
          }
        },
        error: (error) => {
          console.error('Error fetching projects:', error);
        },
      });
  }

  enrichOrganizations(): void {
    // Combine `selected_organizations` with corresponding `responses`
    this.enrichedOrganizations =
      this.submittedInitiation?.selected_organizations.map(
        (org: any, index: number) => ({
          ...org,
          response: this.submittedInitiation?.responses[index] || {},
        })
      );
  }
  tooltipVisibilityToggle() {
    this.showTooltip = !this.showTooltip;
  }
  formatDate(dateString: string): string | null {
    if (!dateString) return null;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Add leading zero
    const day = ('0' + date.getDate()).slice(-2); // Add leading zero

    return `${year}-${month}-${day}`;
  }

  preInitiationData() {
    this.projectsService.getPreInitiationData().subscribe({
      next: (response: any) => {
        this.eoiData = response.data;
        if (this.eoiData) {
          // Convert latitude and longitude to numbers
          const latitude = parseFloat(this.eoiData.projectDetails.latitude);
          const longitude = parseFloat(this.eoiData.projectDetails.longitude);

          // Check if the conversion was successful
          if (!isNaN(latitude) && !isNaN(longitude)) {
            const url = `https://www.google.com/maps/embed/v1/place?key=${this.google_api_key}&q=${latitude},${longitude}&zoom=12`;
            this.mapLink = this.sanitizer?.bypassSecurityTrustResourceUrl(url);
          } else {
            this.mapLink = null;
          }
        }
      },
      error: (error: any) => {
        console.error('Failed to fetch EOI initiation data:', error);
      },
    });
  }

  async sendInvitations() {
    this.projectsService.initiateEOI().subscribe({
      next: (response: any) => {
        this.handleClose();
        localStorage.removeItem('eoi_id');
        this.tenderingService.setEoiId('');
        this.toast.success(response.meta.message, 'SUCCESS', 4000);
      },
      error: (error: any) => {
        console.error('Login failed:', error);
        this.toast.danger(error.error.data, 'DANGER', 4000);
      },
    });
  }

  goBack() {
    console.log('Going back');
    // Navigation logic here
  }

  getSanitizedHtml(description: string) {
    if (!description) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }
  handleClose() {
    this.router.navigate(['/eoi-submissions'], {
      queryParams: {
        projectName: this.projectName,
        projectIdentifier: this.projectIdentifier,
      },
    });
  }

  async openIndividualEOIResponsePreview(eoiResponseId: any, projectId: any) {
    const isEoiResponseSubmitted = await this.fetchEoiStatus(eoiResponseId);
    if (isEoiResponseSubmitted) {
      this.dialog.open(EOIIndividualResponsePreviewComponent, {
        width: '70vw',
        height: '80vh',
        maxWidth: 'unset',
        autoFocus: false,
        data: {
          eoiResponseId: eoiResponseId,
          projectId: projectId,
          submittedInitiation: this.submittedInitiation,
        },
      });
    } else {
      this.toast.warning(
        WarningMessages.COMPANY_RESPONSE_MISSING_WARNING,
        'WARNING'
      );
    }
  }

  handleEdit(selectedEoiId) {
    this.tenderingService.setProjectIdentifier(this.projectIdentifier);
    this.tenderingService
      .getEOICurrentStageData(this.projectId, selectedEoiId)
      .subscribe({
        next: (response: any) => {
          if (response?.data) {
            this.savedEOIData = response.data;
          }
        },
        error: (error: any) => {
          console.error('Failed to fetch:', error);
        },
      });
    this.isEdit = !this.isEdit;
    this.tenderingService.setEditState(this.isEdit);
  }

  handleDialog() {
    this.isEdit = false;
    this.submittedInitiationData();
  }

  handleApprovals() {
    this.sendApprovals = true;
    const dialogRef = this.dialog.open(InternalApprovalComponent, {
      width: '80vw',
      height: 'auto',
      maxWidth: 'unset',
      autoFocus: false,
      data: {
        ResponseId: this.eoiId,
        projectId: this.projectId,
        users: this.usersList,
        approvalResponses: this.approvalResponses,
        modalType: 'eoi',

      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'closeApproval') {
        this.getEoiApprovalsStatus();
        this.sendApprovals = false;
      }
    });
  }

  fetchUsers() {
    this.userService.getUsers().subscribe(
      (response: any) => {
        if (response) {
          this.usersList = response.map((user: any) => ({
            id: user?.id,
            name: user?.name,
            email: user?.email,
            role: this.roles[Math.floor(Math.random() * this.roles.length)],
          }));
        } else {
          console.error("Response does not contain 'data' property.");
        }
      },
      (error) => {
        console.log('Failed to load users: ', error);
      }
    );
  }

  approvalResponseView(ResponseId: any, projectId: any) {
    this.sendApprovals = true;
    const dialogRef = this.dialog.open(ApprovalResponseComponent, {
      width: '80vw',
      height: '80vh', // Set fixed height
      maxHeight: '80vh',
      maxWidth: '80vw',
      autoFocus: false,
      data: {
        ResponseId: ResponseId,
        projectId: projectId,
        note: this.approvalNote,
        modalType: 'eoi',
        approvalSender: this.approvalResponses,
        
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'closeApproval') {
        this.sendApprovals = false;
        this.getEoiApprovalsStatus();
      }
    });
  }

  async getEoiApprovalsStatus(): Promise<void> {
    try {
      const response = await this.projectsService
        .getApprovalsStatus(this.projectId, this.eoiId, 'eoi')
        .toPromise();

      if (response?.data) {
        this.internalApproval = response?.data;
        this.approvalNote = response?.data?.internal_approvals?.notes;
        this.approvalsStatus = response?.data?.internal_approvals?.status
          ? response?.data?.internal_approvals?.status
          : 'pending';
        let responses =
          response?.data?.internal_approvals?.internal_approval_responses;
        if (responses) {
          responses = responses.map((user: any) => ({
            id: user.user_id,
            role: this.roles[Math.floor(Math.random() * this.roles.length)],
            status: user?.status,
            comment: user?.comment,
            name: user?.name,
            email: user?.user?.email,
          }));
        }

        const userId = +this.orgInfo?.pivot?.user_id;

        const inApprovers =
          response?.data?.internal_approvals?.internal_approval_responses.find(
            (response: any) => response?.user_id === userId
          );

        if (inApprovers) {
          this.isInApprovers = true;
        } else {
          this.isInApprovers = false;
        }

        this.approvalResponses = responses;
        if (responses && this.orgInfo?.pivot?.user_id) {
          const matchingResponse = responses.find(
            (response: any) =>
              response?.id === userId && response?.status !== 'pending'
          );
          this.checkApprove = !!matchingResponse;

          if (this.checkApprove) {
            this.approvalResponses = null;

            this.approvalResponses = matchingResponse;
          }
        } else {
          this.checkApprove = false;
        }
      }
    } catch (error) {
      console.error('Error approvals status:', error);
    }
  }

  fetchEoiStatus(eoiResponseId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.tenderingService
        .checkEoiResponseStatus(this.projectId, this.eoiId, eoiResponseId)
        .subscribe({
          next: (response: any) => {
            if (response.meta.success) {
              resolve(response?.data);
            } else {
              reject('Failed to fetch response');
            }
          },
          error: (error) => {
            reject(error);
          },
        });
    });
  }
}
